import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SiteLayoutComponent } from './layouts/site-layout/site-layout.component';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';
import { LoginComponent } from './modules/login/components/login/login.component';
import { DashboardComponent } from './modules/dashboard/components/dashboard/dashboard.component';
import { AuthGuard } from './modules/login/services/guards/auth.guard';
import { TravelAuthorizationComponent } from './modules/travel/components/travel-authorization/travel-authorization.component';
import { TravelCashAdvanceListComponent } from './modules/travel-cash-advance/components/travel-cash-advance-list/travel-cash-advance-list.component';
import { TravelReimbursementListComponent } from './modules/travel-reimbursement/components/travel-reimbursement-list/travel-reimbursement-list.component';
import { TravelLiquidationListComponent } from './modules/travel-liquidation/components/travel-liquidation-list/travel-liquidation-list.component';
import { TravelApproverComponent } from './modules/travel/components/travel-approver/travel-approver.component';
import { TravelCashApproverComponent } from './modules/travel-cash-advance/components/travel-cash-approver/travel-cash-approver.component';
import { TravelReimbursementApproverComponent } from './modules/travel-reimbursement/components/travel-reimbursement-approver/travel-reimbursement-approver.component';
import { TravelLiquidationApproverComponent } from './modules/travel-liquidation/components/travel-liquidation-approver/travel-liquidation-approver.component';
import { StateSummaryComponent } from './modules/report/components/state-summary/state-summary.component';
import { DepartmentSummaryComponent } from './modules/report/components/department-summary/department-summary.component';
import { AgingPerEmployeeComponent } from './modules/report/components/aging-per-employee/aging-per-employee.component';
import { AgingPerDeparmentComponent } from './modules/report/components/aging-per-deparment/aging-per-deparment.component';
import { EmployeeTransactionComponent } from './modules/report/components/employee-transaction/employee-transaction.component';

const routes: Routes = [
  //Site Layout Routes
  {
  	path: '',
  	redirectTo: 'dashboard',
  	pathMatch: 'full'
  },
  {
    path: '',
    component: SiteLayoutComponent,
    children:[
      { path: 'login', component: LoginComponent },
    ]
  },

  //App Layout Routes
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'travel-request', component: TravelAuthorizationComponent },
      { path: 'travel-request-approver', component: TravelApproverComponent },
      // { path: 'travel-cash-advance', component: TravelCashAdvanceListComponent },
      // { path: 'travel-cash-approver', component: TravelCashApproverComponent },
      { path: 'reimbursement', component: TravelReimbursementListComponent },
      { path: 'reimbursement-approver', component: TravelReimbursementApproverComponent },
      { path: 'liquidation', component: TravelLiquidationListComponent },
      { path: 'liquidation-approver', component: TravelLiquidationApproverComponent },
      { path: 'status-summary', component: StateSummaryComponent },
      { path: 'per-department-summary', component: DepartmentSummaryComponent },
      { path: 'aging-per-employee', component:  AgingPerEmployeeComponent},
      { path: 'aging-per-deparment', component:  AgingPerDeparmentComponent},
      { path: 'employee-transaction', component: EmployeeTransactionComponent}
    ]  
  },
  //No Layout
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
